<template>
	<ul class="switch_nav" :class="{ switch_nav_fixed: fixed }">
		<li><button :class="{ disabled: index != 0 }" @click="handleItemClick(0)">辅助工具下载</button></li>
		<!-- 专业版下载 -->
		<li><button :class="{ disabled: index != 1 }" @click="handleItemClick(1)">专业版下载</button></li>
		<li><button :class="{ disabled: index != 2 }" @click="handleItemClick(2)">趣味版下载</button></li>
		<!-- <li><button :class="{'disabled': index != 3}" @click="handleItemClick(3)">视知觉V2下载</button></li> -->
	</ul>
</template>

<script>
export default {
	props: {
		index: {
			type: Number,
			default: 0
		},
		fixed: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		/*************** @Events ******************/
		// 点击每一项
		handleItemClick(index) {
			this.$emit('onClick', index);
		}
	}
};
</script>

<style scoped>
.switch_nav {
	position: absolute;
	width: 235px;
	top: 580px;
	left: 50%;
	margin-left: -600px;
}

.switch_nav_fixed {
	position: fixed;
	top: 100px;
}

.switch_nav li {
	margin-bottom: 18px;
}

.switch_nav button {
	width: 100%;
	height: 80px;
	border-radius: 10px;
	font-size: 30px;
}

@media screen and (max-width: 1200px) {
	.switch_nav_fixed {
		left: 0;
		margin-left: 0;
	}
}
</style>
